import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Editor } from 'ngx-editor';
import { MailContext } from 'src/app/models/mail-context';
import { Template } from 'src/app/models/template';
import { EmailService } from 'src/app/services/email.service';
import { MessagesService } from 'src/app/services/messages.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';

@Component({
    selector: 'app-send-email',
    templateUrl: './send-email.component.html',
    styleUrls: ['./send-email.component.scss']
})
export class SendEmailComponent {
    private _template?: Template;
    private _context?: string;
    private _receiver: string = '';
    private _subject : string = '';

    protected editor!: Editor;

    public form = new FormGroup({
        receiver: new FormControl('', [Validators.required]),
        subject: new FormControl('', [Validators.required]),
        data: new FormControl('', [Validators.required]),
    });

    @Output()
    public done = new EventEmitter();

    public templates: Template[] = [];
    public selectTemplates: Template[] = [];
    public variables: Record<string, string> = {};
    public conditions: Record<string, number | null> = {};

    
    public get receiver() : string {
        return this._receiver;
    }
    public set receiver(v : string) {
        this._receiver = v;
        this.form.controls.receiver.reset(v);
    }
    
    public get subject() : string {
        return this._subject;
    }
    public set subject(v : string) {
        this._subject = v;
        this.form.controls.subject.reset(v);
    }

    public get template(): Template | undefined { return this._template; }
    public set template(val: Template | undefined) {
        this._template = val;
        this.updateData();
    }

    @Input()
    public data: Record<string, unknown> = {};

    public get contextId(): string | undefined { return this._context; }
    @Input()
    public set contextId(val: string | undefined) {
        this._context = val;
        this.updateTemplates();
    }

    private updateTemplates() {
        if (this.contextId) this.selectTemplates = this.templates.filter(t => t.context === this.contextId);
        else this.selectTemplates = [...this.templates];
    }

    public async submit() {
        try {
            await this.email.send(
                this.form.value.receiver!,
                this.form.value.subject!,
                this.form.value.data!,
            );
            this.msgs.success('Имейлът е изпратен!');
            this.done.emit();
        }
        catch (e) { this.msgs.error(e); }
    }

    public constructor(
        private email: EmailService,
        private msgs: MessagesService,
        private wait: WaitIndicatorService,
    ) { }

    ngOnInit(): void {
        this.editor = new Editor();
    }

    ngOnDestroy(): void {
        this.editor.destroy();
    }

    public load = async (): Promise<void> => {
        this.wait.show();
        this.templates = await this.email.all();
        this.wait.hide();
    }

    private async updateData() {
        const data = await this.email.substituteTemplate("enroll", this._template!.text, this.variables, this.conditions);
        this.form.controls.data.reset(data);
        this.form.controls.subject.reset(this._template?.subject ?? '');
    }
}
